import React, { useContext } from "react";

import { icons } from "constants/icons";
import { Link, useHistory } from "react-router-dom";
import { PAGES } from "constants/pages";
import SettingsIcon from "@mui/icons-material/Settings";
import { AuthContext } from "contexts/authContext";
import { Avatar, Grid, Button } from "@mui/material";
import ReportsButton from "components/Header/ReportsButton";
import {
  avatarNameStyle,
  avatarStyle,
  headerStyle,
  settingStyle,
  singOutStyle,
  userMenuStyle,
  btnStyle,
} from "pages/auth/styles";
import { selectCurrentClinician } from "store/ClinicianStore/selectors";
import { useAppSelector } from "hooks/reduxHooks";

type Props = {
  showSettings: boolean;
};

export const Header = ({ showSettings }: Props) => {
  const authContext = useContext(AuthContext);
  const [buttonDisabled, setButtonDisabled] = React.useState(
    window.location.pathname.includes("report")
  );
  const history = useHistory();

  const isFromCronJob = window.location.search.includes("fromCronJob=true");

  const currentClinician = useAppSelector(selectCurrentClinician);

  const onSignOut = () => {
    authContext.signOut();
  };

  history.listen((data) => {
    if (data.pathname.includes("report")) {
      setButtonDisabled(true);
    } else {
      setButtonDisabled(false);
    }
  });

  const emails = [
    "hsiangjung+autoc47@topflightapps.com",
    "colin.mansfieldmd@gmail.com",
  ];

  return (
    <div
      className="w-full min-h-40 flex items-center bg-bgDark py-5 px-6"
      style={headerStyle}
    >
      <Link to={PAGES.homeScreen}>
        <img className="logo" src={icons.logo} alt="logo" />
      </Link>
      {showSettings && !isFromCronJob ? (
        <Grid container justifyContent="end">
          <Grid sx={{ ml: 5, mr: 5 }}>
            {((window.location.host === "clinic.allheartz.com" &&
              emails.includes(currentClinician?.profileInfo.email || "")) ||
              window.location.host === "clinic-staging.allheartz.com") && (
              <ReportsButton disabled={false} history={history} />
            )}
          </Grid>
          <Grid style={userMenuStyle as any}>
            <p style={avatarNameStyle}>
              Hi, {currentClinician?.profileInfo.firstName}{" "}
              {currentClinician?.profileInfo.lastName}
            </p>
            <Link to="/" onClick={onSignOut} style={singOutStyle}>
              Sign Out
            </Link>
          </Grid>
          <Avatar src={currentClinician?.imageUrl} style={avatarStyle}>
            H
          </Avatar>
          <Link to={PAGES.userProfile} style={settingStyle}>
            <SettingsIcon />
          </Link>
        </Grid>
      ) : null}
    </div>
  );
};
